module.exports = __webpack_public_path__ + "media/videos/home/hero-poster-970259c4878d79a9dbcf0b26bf94becd.jpg";